// Hero Slider with Text

import './index.scss';

import Swiper, { Navigation } from 'swiper';

export default class HeroSliderText {
  constructor(root) {
    this.root = root;

    let slider = this.root.querySelector('.swiper');
    if (slider.children.length > 1) {
      const swiper = new Swiper(slider, {
        modules: [Navigation],
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }
  }
}
